import { configureStore } from "@reduxjs/toolkit";
import UserSlice from "./User/UserSlice";
import FactorySlice from "./Factory/FactorySlice";
import AuthSlice from "./User/AuthSlice";
import VendorSlice from "./Vendor/VendorSlice";
import QualitySlice from "./Quality/QualitySlice";
import LabourCostSlice from "./LabourCost/LabourCost";
import AppLevelSlice from "./AppLevelApi/AppLevelSlice";
import SubQualitySlice from "./SubQuality/SubQualitySlice";
import OperatorSlice from "./Operator/OperatorSlice";
import LeafWareHouseSlice from "./LeafWareHouse/LeafWareHouseSlice";
import ProductSlice from "./Products/ProductSlice";
import CartoonTypeSlice from "./CartoonType/CartoonTypeSlice";
import PlasticTypeSlice from "./PlasticType/PlasticTypeSlice";
import ProductionSlice from "./Production/ProductionSlice";
import MoldSlice from "./Mold/MoldSlice";
import CartoonStockSlice from "./CartoonStock/CartoonStockSlice";
import PlasticStockSlice from "./PlasticStock/PlasticStockSlice";
import LeafStockSlice from "./LeafStock/LeafStockSlice";
import StickerStock from "./StickerStock/StickerStockSlice";
import ReportSlice from "./Report/ReportSlice";
import CartoonWithDraw from "./CartoonWithDraw/CartoonWithDrawSlice";
import PlasticWithDraw from "./PlasticWithDraw/PlasticWithDrawSlice";
const store = configureStore({
  reducer: {
    user: UserSlice,
    factory: FactorySlice,
    auth: AuthSlice,
    vendor: VendorSlice,
    quality: QualitySlice,
    labourcost: LabourCostSlice,
    applevel: AppLevelSlice,
    subquality: SubQualitySlice,
    operator: OperatorSlice,
    product: ProductSlice,
    leafwarehouse: LeafWareHouseSlice,
    cartoontype: CartoonTypeSlice,
    plastictype: PlasticTypeSlice,
    production: ProductionSlice,
    mold: MoldSlice,
    cartoonstock: CartoonStockSlice,
    plasticstock: PlasticStockSlice,
    leafstock: LeafStockSlice,
    stickerstock: StickerStock,
    report: ReportSlice,
    cartoonwithdraw: CartoonWithDraw,
    plasticwithdraw: PlasticWithDraw,
  },
});

export default store;
